import { createPageAnalytics, trackEvent } from "common/analytics";

export const contributeOptionsAnalytics =
  createPageAnalytics("contribute_options");

/**
 * The place a contribution is for, as the `*_cta_activated` events name it.
 * Same shape as native's (apps/native/src/analytics/contributeAnalytics.ts);
 * the picker only ever sees the action, so its caller passes this in.
 */
export type ContributeVenueContext = {
  brand_id: string;
  brand_name: string;
  business_id: string;
  place_name: string;
};

/**
 * A "Contribute" / "Add info" tap that opens the picker. `entry_point` is
 * where it happened: place_landing on the place page, place_card on a venue
 * or map card.
 */
export function trackContributeCta(entryPoint: string): void {
  trackEvent("contribute_cta_activated", { entry_point: entryPoint });
}

/**
 * Picking an option in "What you can do". On the web only "Share your
 * experience" can be picked — photos and alerts are marked mobile-only and do
 * nothing — so this is the one event it sends.
 */
export function trackContributeContinue(venue: ContributeVenueContext): void {
  trackEvent("place_experience_share_cta_activated", {
    ...venue,
    entry_page: "contribute_options",
  });
}
